import React from 'react';
import { Text, Stack, Paper, Group, ThemeIcon } from '@mantine/core';
import {
    IconPlaylistAdd,
    IconFileSearch,
    IconListDetails,
} from '@tabler/icons-react';
import { Icon, ICONS } from '@/common/components/Icon';
import { useTranslation } from 'react-i18next';

export interface FeatureItem {
    id: string;
    title: string;
    description: string;
    icon: React.ReactNode;
    isNew?: boolean;
}

interface DemoFeaturesProps {
    onSelectFeature?: (featureId: string) => void;
}

const DemoFeatures: React.FC<DemoFeaturesProps> = ({
    onSelectFeature = (id: string) => {
        // 기본 핸들러
        console.log(`%c[DemoFeatures] 기능 선택됨: ${id}`, 'background: #4CAF50; color: white; font-weight: bold; padding: 2px 5px; border-radius: 3px;');
    },
}) => {
    const { t } = useTranslation('ai');
    const features: FeatureItem[] = [
        {
            id: 'get-todo',
            title: t('features.getTodo.title'),
            description: t('features.getTodo.description'),
            icon: <IconListDetails size={20} color="#212529" />,
            isNew: true,
        },
        {
            id: 'create-todo',
            title: t('features.createTodo.title'),
            description: t('features.createTodo.description'),
            icon: <IconPlaylistAdd size={20} color="#212529" />,
            isNew: true,
        },
        // {
        //     id: 'create-report',
        //     title: t('features.createReport.title'),
        //     description: t('features.createReport.description'),
        //     icon: <Icon name={ICONS.AI.AIREPORT} size={16} />,
        //     isNew: true,
        // },
        {
            id: 'search-note',
            title: t('features.searchNote.title'),
            description: t('features.searchNote.description'),
            icon: <IconFileSearch size={20} color="#212529" />,
            isNew: true,
        },
    ];

    return (
        <Stack
            gap="xs"
            p="xs"
            align="center"
            justify="center"
            style={{
                width: '330px',
                margin: '0 auto',
                height: '410px',
                display: 'flex',
            }}
        >
            {features.map(feature => (
                <Paper
                    key={feature.id}
                    shadow="xs"
                    p="xs"
                    radius="md"
                    withBorder
                    style={{
                        cursor: 'pointer',
                        alignItems: 'center',
                        // transition: 'transform 0.2s, box-shadow 0.2s',
                        height: '62px',
                        width: '330px',
                        borderColor: '#DEE2E6',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        },
                    }}
                    onClick={() => onSelectFeature(feature.id)}
                >
                    <Group justify="space-between" mb={2}>
                        <Group gap="xs">
                            <ThemeIcon
                                variant="light"
                                radius="xl"
                                size={22}
                                style={{
                                    backgroundColor: '#E7F5FF',
                                    padding: '2px',
                                    color: '#212529',
                                }}
                            >
                                {feature.icon}
                            </ThemeIcon>
                            <Text fw={600} size="sm">
                                {feature.title}
                            </Text>
                        </Group>
                    </Group>

                    <Text size="xs" c="dimmed" ml={28}>
                        {feature.description}
                    </Text>
                </Paper>
            ))}
        </Stack>
    );
};

export default DemoFeatures;
